define.alias("shared/helpers/format-profile-categorization-value", "media/helpers/format-profile-categorization-value");